import {AppContext} from "@/ts/appContext";

type AtLeastOne =
  | {usertype: string; path?: undefined}
  | {usertype?: undefined; path: string};

// Récupère le contexte de l'application en fonction du type d'utilisateur et du path
// On récupère le type d'utilisateur, l'url de l'app ainsi que les urls des API en fonction du hostname
export function getAppContext(params: AtLeastOne): AppContext | undefined {
  const {usertype, path} = params;
  // On définit les contextes de l'application en fonction du type d'utilisateur et du path
  const appContextArray: AppContext[] = [
    {
      userType: "Fournisseur",
      pathUrl: "pdp-fournisseur-staging.cofaq.fr",
      API: "https://pdp-fournisseurs-bff-preprod.cofaq.fr", // URL BFF Fournisseur
    },
    {
      userType: "Collaborateur",
      pathUrl: "pdp-collaborateur-staging.cofaq.fr",
      API: "https://referentiel-bff-spa-preprod.cofaq.fr", // URL RAC
    },
    {
      userType: "Adherent",
      pathUrl: "pdp-adherent-staging.cofaq.fr",
      API: "https://pdp-adherents-bff-preprod.cofaq.fr", // URL BFF Adhérent
    },
    {
      userType: "Adherent",
      pathUrl: "coact-adherent.cofaq.fr",
      API: "https://coact-adherents-bff.cofaq.fr",
    },
    {
      userType: "Collaborateur",
      pathUrl: "coact-collaborateur.cofaq.fr",
      API: "https://referentiel-bff-spa.cofaq.fr",
    },
    {
      userType: "Fournisseur",
      pathUrl: "coact-fournisseur.cofaq.fr",
      API: "https://coact-fournisseur-bff.cofaq.fr",
    },
  ];

  const appContext = appContextArray.find(
    context =>
      context.userType === usertype ||
      context.pathUrl === path?.replace(/\/$/, "")
  );
  return appContext;
}
